"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliceScopedLogger = void 0;
function isContextObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value) && !(value instanceof Error);
}
class SliceScopedLogger {
    constructor(sliceKey, delegate) {
        this.sliceKey = sliceKey;
        this.delegate = delegate;
    }
    info(message, ...meta) {
        this.delegate.info(message, ...this.stamp(meta));
    }
    warn(message, ...meta) {
        this.delegate.warn(message, ...this.stamp(meta));
    }
    error(message, ...meta) {
        this.delegate.error(message, ...this.stamp(meta));
    }
    debug(message, ...meta) {
        this.delegate.debug?.(message, ...this.stamp(meta));
    }
    verbose(message, ...meta) {
        this.delegate.verbose?.(message, ...this.stamp(meta));
    }
    stamp(meta) {
        const [first, ...rest] = meta;
        if (isContextObject(first)) {
            return [{ ...first, sliceKey: this.sliceKey }, ...rest];
        }
        return [...meta, { sliceKey: this.sliceKey }];
    }
}
exports.SliceScopedLogger = SliceScopedLogger;
//# sourceMappingURL=slice-scoped-logger.js.map